import React from 'react';
import styled from 'styled-components';

import { Color, Grid } from '../../../app/StyleGuide';
import type { User } from '../../authentication/domain/User';
import alertService from '../../../services/AlertService';
import userService from '../../../services/userService';
import windowService from '../../../services/windowService';
import { useUser } from '../../authentication';

const IMPERSONATION_ENDED_ACTION = 'ended';

function getServiceErrorMessage(error: unknown): string | undefined {
  return (error as { response?: { data?: string } } | undefined)?.response?.data;
}

const BannerBar = styled.div`
  box-sizing: border-box;
  height: ${Grid._5};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background: ${Color.Red._50};
  font-size: 12px;
  line-height: 1;
  cursor: pointer;

  p {
    color: ${Color.white};
    margin: 0;
    text-align: center;
  }
`;

export function ImpersonationBanner() {
  const { user } = useUser();
  const stopImpersonation = () => {
    if (!user?.impersonatingWas) return;

    userService
      .impersonateUser(user.impersonatingWas)
      .then(() => windowService.redirectTo(`/admin/impersonate?action=${IMPERSONATION_ENDED_ACTION}`))
      .catch((error: unknown) => {
        alertService.showError(getServiceErrorMessage(error));
      });
  };
  if (!user?.impersonating) return null;
  return (
    <BannerBar onClick={stopImpersonation} data-qa-hook="impersonationBanner">
      <p>
        IMPERSONATING: <strong>{user.logInEmail}</strong>
      </p>
    </BannerBar>
  );
}
